import { z } from 'zod';

const ignoreEmpty = (arg: unknown) => (arg === '' ? undefined : arg);

export const EnvSchema = z
  .object({
    baseUrl: z.preprocess(ignoreEmpty, z.string().optional().default('https://api.cognitedata.com')),
    strictMode: z.boolean().optional().default(false),
    appName: z.preprocess(ignoreEmpty, z.string().optional().default('Cognite Dashboard')),
    dataInstanceSpace: z.preprocess(ignoreEmpty, z.string().optional()),
    basePath: z.preprocess(ignoreEmpty, z.string().optional().default('/')),
    displayTz: z.preprocess(ignoreEmpty, z.string().optional().default('Asia/Dubai')),
    auth: z.preprocess(
      (arg: object) => (Object.values(arg).filter(Boolean).length === 0 ? undefined : arg),
      z
        .object({
          clientId: z.preprocess(ignoreEmpty, z.string()),
          tenantId: z.preprocess(ignoreEmpty, z.string()),
          cluster: z.preprocess(ignoreEmpty, z.string()),
          project: z.preprocess(ignoreEmpty, z.string()),
          redirectUri: z.preprocess(
            ignoreEmpty,
            z
              .string()
              .optional()
              .default(() => document.location.origin),
          ),
        })
        .strict()
        .optional(),
    ),
    cdf: z.preprocess(
      (arg: object) => (Object.values(arg).filter(Boolean).length === 0 ? undefined : arg),
      z
        .object({
          url: z.preprocess(ignoreEmpty, z.string().optional()),
        })
        .strict()
        .optional(),
    ),
  })
  .strict();

export type EnvSchema = z.infer<typeof EnvSchema>;
